
            import { createApp } from "vue";
            import { createPinia } from "pinia";
            import App from "./src/App.vue";
            import { router } from "./src/router/index.ts";
            import { resetAllPlugin } from "./src/stores/plugins/resetAll.ts";
            // AM-W1-α.2 — glass-ui's web-font corpus (Plus Jakarta Sans +
            // Fira Code) ships as a SEPARATE subpath export
            // `@mkbabb/glass-ui/styles/fonts` (~102 KB gz of base64 woff2),
            // split OUT of the critical `@mkbabb/glass-ui/styles` barrel so
            // the render-blocking `index-*.css` stays font-free. The `?url`
            // import makes Rollup emit fonts.css as its own content-hashed
            // asset (resolved as a served URL in dev); `loadFonts` injects
            // it as a non-render-blocking async `<link>` (media="print" →
            // onload flip to "all"), mirroring vite.config.mjs's
            // ag-wperf-l3-css-async idiom for the main sheet.
            import fontsHref from "@mkbabb/glass-ui/styles/fonts?url";
            import { loadFonts } from "./src/fonts/loadFonts.ts";

            loadFonts(fontsHref);

            const app = createApp(App);
            const pinia = createPinia();

            // W10.T4: capture per-store initial-state snapshots so the
            // admin logout flow can reset the admin slabs in lockstep
            // with clearing the bearer token (closes B3b H1 state bleed).
            // Plugin registration happens BEFORE `app.use(pinia)` per
            // Pinia 3.x guidance — the install step binds the queue.
            pinia.use(resetAllPlugin);

            app.use(pinia);
            app.use(router);
            app.mount("#app");
        